
















import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { EvalSettingSimple } from '@/models/evalSetting/eval-setting-simple';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GExamListStartTimeInput',
  components: {},
  computed: {},
  methods: {},
})
export default class GExamListStartTimeInput extends Mixins(GPageBase) {
  tempStartTime: string = ''; // 開始日の最終変更結果を代入する

  @Prop() evalSettingSimple: EvalSettingSimple;
  mounted() {}

  isStartTimeBeforeCurrentTime(startTime: string): boolean {
    return moment(startTime) <= moment(new Date()).add(-5, 'm');
  }

  isDeadlineBeforeStartTime(startTime: string): boolean {
    return moment(this.evalSettingSimple.deadline).isSameOrBefore(moment(startTime));
  }

  handleChangeStartTime(startTime: string) {
    if (this.isStartTimeBeforeCurrentTime(startTime)) {
      this.showNotice(GEnum.MessageType.Error, this.$t('ERROR').toString(), this.$t('NOTICE_START_DATE_BEFORE_NOW').toString());
    }
    if (this.isDeadlineBeforeStartTime(startTime)) {
      this.showNotice(GEnum.MessageType.Error, this.$t('ERROR').toString(), this.$t('NOTICE_START_DATE_BEFORE_END_DATE').toString());
    }
    this.tempStartTime = startTime;
  }

  handleOKStartTime() {
    if (this.isStartTimeBeforeCurrentTime(this.tempStartTime)) {
      this.showNotice(GEnum.MessageType.Error, this.$t('ERROR_UPDATE').toString(), this.$t('NOTICE_START_DATE_BEFORE_NOW').toString());
      return;
    }
    if (this.isDeadlineBeforeStartTime(this.tempStartTime)) {
      this.showNotice(GEnum.MessageType.Error, this.$t('ERROR_UPDATE').toString(), this.$t('NOTICE_START_DATE_AFTER_END_DATE').toString());
      return;
    }
    const tempBeforeStartTime: Date = this.evalSettingSimple.startTime;
    this.evalSettingSimple.startTime = this.tempStartTime !== '' ? moment(this.tempStartTime).toDate() : tempBeforeStartTime;
    this.$emit('handleUpdate', this.evalSettingSimple, tempBeforeStartTime);
  }

  // DatePickerのdisable範囲を設定
  dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    const deadline: Date = this.evalSettingSimple.deadline;
    return {
      disabledDate(date: Date) {
        return (date && moment(date) < moment(startDate).add(-1, 'd')) || (date && moment(date) > moment(deadline)) || moment(new Date(globalModule.selectedSchoolYear + 1, 3, 1)) <= moment(date);
      },
    };
  }
}
